"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
var _communityComment = require("@/api/community/communityComment.js");
var _communityHomeAct = require("@/api/decorate/communityHomeAct.js");
var _memberManagement = require("@/api/member/memberManagement.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HomeActivity',
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      id: null,
      imagePrefix: '',
      // 活动列表数据
      activityList: [],
      selectedActivities: [],
      // 用于预览功能的选中项
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 对话框相关
      dialogVisible: false,
      previewDialogVisible: false,
      // 预览弹窗相关
      previewVisible: false,
      previewImageUrl: '',
      dialogTitle: '添加活动',
      isEdit: false,
      currentEditId: null,
      // 预览数据
      previewData: {},
      actName: '',
      // 活动名称
      // 表单数据
      formData: {
        name: '',
        type: true,
        // true普通，false链接
        timeRange: [],
        // 时间范围 [startTime, endTime]
        coverImg: '',
        explain: '',
        url: '',
        // 链接地址 type=2时有值
        apply: false,
        // 报名1是0否  type = 1有值
        detailImg: '',
        // 详情图 type = 1有值
        status: false,
        // 1启用，0未启用
        backgroundColor: '#ffffff' // 背景颜色，默认白色
      },
      // 表单验证规则
      formRules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择活动类型',
          trigger: 'change'
        }],
        timeRange: [{
          required: true,
          validator: this.validateTimeRange,
          trigger: 'change'
        }],
        url: [{
          required: false,
          message: '请输入链接地址',
          trigger: 'blur'
        }]
      },
      // 上传相关
      uploadHeaders: {}
    };
  },
  created: function created() {
    // 组件创建时可以访问到传入的key值
    console.log('HomeActivity - pageKey:', this.pageKey, 'moduleKey:', this.moduleKey);
    // 页面加载时获取已保存的配置
    this.loadConfig();
    // 获取图片前缀
    this.getImagePrefix();
    // 设置上传请求头
    this.setUploadHeaders();
  },
  methods: {
    // 设置上传请求头
    setUploadHeaders: function setUploadHeaders() {
      var token = localStorage.getItem('Admin-Token');
      if (token) {
        this.uploadHeaders['Authorization'] = token;
      }
    },
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    // 处理表格选择变化
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedActivities = selection;
    },
    // 预览功能
    preview: function () {
      var _preview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var loadingInstance, ids, previewData, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.selectedActivities.length === 0)) {
                _context2.next = 1;
                break;
              }
              this.$message.warning('请至少选择一条数据进行预览');
              return _context2.abrupt("return");
            case 1:
              loadingInstance = null;
              _context2.prev = 2;
              // 获取选中数据的ID
              ids = this.selectedActivities.map(function (item) {
                return item.id;
              }); // 构造预览参数
              previewData = {
                ids: ids,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                xcxType: this.xcxType,
                pageURl: "" // 设置默认页面URL，可根据实际需求调整
              }; // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '预览生成中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用社区首页活动预览接口
              _context2.next = 3;
              return (0, _communityHomeAct.homeActPreview)(previewData);
            case 3:
              response = _context2.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  // 检查是否有二维码URL直接返回
                  if (response.data.image && typeof response.data.image === 'string') {
                    // 如果返回了二维码URL，显示预览弹窗
                    this.previewImageUrl = response.data.image;
                    this.previewVisible = true;
                  } else {
                    this.$message.success('预览二维码生成成功');
                  }
                } else {
                  this.$message.success('预览二维码生成成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context2.next = 5;
              break;
            case 4:
              _context2.prev = 4;
              _t2 = _context2["catch"](2);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('预览失败:', _t2);
              this.$message.error('预览失败: ' + (_t2.message || '未知错误'));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function preview() {
        return _preview.apply(this, arguments);
      }
      return preview;
    }(),
    // 验证时间范围
    validateTimeRange: function validateTimeRange(rule, value, callback) {
      if (!this.formData.timeRange || this.formData.timeRange.length !== 2 || !this.formData.timeRange[0] || !this.formData.timeRange[1]) {
        callback(new Error('请选择活动时间'));
      } else if (new Date(this.formData.timeRange[0]) >= new Date(this.formData.timeRange[1])) {
        callback(new Error('结束时间必须大于开始时间'));
      } else {
        callback();
      }
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadConfig();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadConfig();
    },
    // 添加活动
    handleAddActivity: function handleAddActivity() {
      this.dialogTitle = '添加活动';
      this.isEdit = false;
      this.dialogVisible = true;
      this.resetForm();
    },
    // 编辑活动
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var loadingInstance, response, detailData, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loadingInstance = false;
              _context3.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取活动详情
              _context3.next = 2;
              return (0, _communityHomeAct.getCommunityHomeActDetail)(row.id);
            case 2:
              response = _context3.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.data) {
                // 解析详情数据
                detailData = response.data;
                this.dialogTitle = '编辑活动';
                this.isEdit = true;
                this.currentEditId = detailData.id;
                this.dialogVisible = true;

                // 填充表单数据
                this.formData = {
                  name: detailData.name || '',
                  type: detailData.type,
                  timeRange: [new Date(detailData.startTime) || '', new Date(detailData.endTime) || ''],
                  coverImg: detailData.coverImg || '',
                  explain: detailData.explain || '',
                  url: detailData.url || '',
                  apply: detailData.apply,
                  detailImg: detailData.detailImg || '',
                  status: detailData.status,
                  backgroundColor: detailData.backgroundColor || '#ffffff' // 背景颜色，默认白色
                };
              } else {
                this.$message.error(response.message || '加载详情失败!');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('加载详情失败:', _t3);
              this.$message.error('加载详情失败: ' + (_t3.message || '未知错误'));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    // 预览活动
    handlePreview: function handlePreview(row) {
      this.previewData = {
        name: row.name || '',
        startTime: row.startTime || '',
        endTime: row.endTime || '',
        coverImg: row.coverImg || '',
        explain: row.explain || ''
      };
      this.previewDialogVisible = true;
    },
    // 移除活动
    handleRemove: function handleRemove(row) {
      var _this = this;
      this.$confirm('确定要移除这条活动吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _communityHomeAct.deleteCommunityHomeAct)(row.id);
            case 1:
              response = _context4.sent;
              if (!(response.code === 200)) {
                _context4.next = 3;
                break;
              }
              _context4.next = 2;
              return _this.loadConfig();
            case 2:
              _this.$message.success('移除成功');
              _context4.next = 4;
              break;
            case 3:
              _this.$message.error(response.message || '删除失败!');
            case 4:
              _context4.next = 6;
              break;
            case 5:
              _context4.prev = 5;
              _t4 = _context4["catch"](0);
              console.error('删除失败:', _t4);
              _this.$message.error('删除失败: ' + (_t4.message || '未知错误'));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 5]]);
      }))).catch(function () {
        _this.$message.info('已取消移除');
      });
    },
    // 切换显示状态
    handleToggleVisibility: function () {
      var _handleToggleVisibility = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var response, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return (0, _decorateConfigItem.enableConfigItem)(row.id);
            case 1:
              response = _context5.sent;
              if (response.code === 200) {
                // 更新成功后刷新列表
                this.handleSizeChange(this.pageSize);
                this.$message.success("\u6D3B\u52A8".concat(row.enable ? '已开启' : '已关闭', "\u663E\u793A"));
              } else {
                // 如果接口调用失败，恢复开关状态
                row.enable = !row.enable;
                this.$message.error(response.message || '操作失败!');
              }
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t5 = _context5["catch"](0);
              // 如果接口调用失败，恢复开关状态
              row.enable = !row.enable;
              console.error('操作失败:', _t5);
              this.$message.error('操作失败: ' + (_t5.message || '未知错误'));
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function handleToggleVisibility(_x2) {
        return _handleToggleVisibility.apply(this, arguments);
      }
      return handleToggleVisibility;
    }(),
    // 活动类型改变
    handleTypeChange: function handleTypeChange(value) {
      // 清空对应类型的特有字段
      if (value === true) {
        this.formData.url = '';
      } else if (value === false) {
        this.formData.detailImg = '';
        this.formData.apply = false;
      }
    },
    // 提交表单
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var loadingInstance, data, response, _t6;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              loadingInstance = null; // 表单验证
              _context6.next = 1;
              return this.$refs.activityForm.validate();
            case 1:
              _context6.prev = 1;
              // 显示保存loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 准备数据
              data = {
                name: this.formData.name,
                type: this.formData.type,
                // true为(普通活动)，false为(链接活动)
                startTime: this.formData.timeRange && this.formData.timeRange[0] ? new Date(this.formData.timeRange[0]).getTime() : '',
                endTime: this.formData.timeRange && this.formData.timeRange[1] ? new Date(this.formData.timeRange[1]).getTime() : '',
                coverImg: this.formData.coverImg,
                explain: this.formData.explain,
                url: this.formData.url,
                apply: this.formData.apply,
                // true为1，false为0
                detailImg: this.formData.detailImg,
                status: this.formData.status,
                // true为1，false为0
                backgroundColor: this.formData.backgroundColor,
                // 背景颜色
                pageCode: this.pageKey,
                optionCode: this.moduleKey
              };
              if (!this.isEdit) {
                _context6.next = 3;
                break;
              }
              // 更新操作
              data.id = this.currentEditId;
              _context6.next = 2;
              return (0, _communityHomeAct.updateCommunityHomeAct)(data);
            case 2:
              response = _context6.sent;
              _context6.next = 5;
              break;
            case 3:
              _context6.next = 4;
              return (0, _communityHomeAct.saveCommunityHomeAct)(data);
            case 4:
              response = _context6.sent;
            case 5:
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (!(response.code === 200)) {
                _context6.next = 7;
                break;
              }
              // 保存成功后关闭对话框
              this.handleDialogClose();
              this.isEdit = false;
              this.dialogVisible = false;
              // 刷新列表数据
              _context6.next = 6;
              return this.loadConfig();
            case 6:
              this.$message.success('保存成功');
              _context6.next = 8;
              break;
            case 7:
              this.$message.error(response.message || '保存失败!');
            case 8:
              _context6.next = 10;
              break;
            case 9:
              _context6.prev = 9;
              _t6 = _context6["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('保存失败:', _t6);
              this.$message.error('保存失败: ' + (_t6.message || '未知错误'));
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 9]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    // 关闭对话框
    handleDialogClose: function handleDialogClose() {
      this.resetForm();
      console.log('关闭对话框');
      console.log(this.formData);
    },
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 重置表单
    resetForm: function resetForm() {
      this.currentEditId = null;
      this.formData = {
        name: '',
        type: true,
        // true为普通活动，false为链接活动
        timeRange: [],
        coverImg: '',
        explain: '',
        url: '',
        apply: false,
        detailImg: '',
        status: false,
        backgroundColor: '#ffffff' // 背景颜色，默认白色
      };
      if (this.$refs.activityForm) {
        this.$refs.activityForm.clearValidate();
      }
    },
    // 上传封面图
    uploadCoverImage: function uploadCoverImage(option) {
      var _this2 = this;
      (0, _communityComment.uploadCommunityPic)(option.file).then(function (response) {
        if (response.code === 200) {
          _this2.formData.coverImg = response.data;
          option.onSuccess(response);
        } else {
          option.onError(response);
        }
      }).catch(function (error) {
        option.onError(error);
      });
    },
    // 上传详情图
    uploadDetailImage: function uploadDetailImage(option) {
      var _this3 = this;
      (0, _communityComment.uploadCommunityPic)(option.file).then(function (response) {
        if (response.code === 200) {
          _this3.formData.detailImg = response.data;
          option.onSuccess(response);
        } else {
          option.onError(response);
        }
      }).catch(function (error) {
        option.onError(error);
      });
    },
    // 上传前检查（封面图）
    beforeCoverUpload: function beforeCoverUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('封面图只能是图片格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('封面图大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    // 上传前检查（详情图）
    beforeDetailUpload: function beforeDetailUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('详情图只能是图片格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('详情图大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    // 封面图上传成功
    handleCoverSuccess: function handleCoverSuccess(response, file) {
      if (response.code === 200) {
        this.formData.coverImg = response.data;
        this.$message.success('封面图上传成功');
      } else {
        this.$message.error(response.message || '封面图上传失败');
      }
    },
    // 详情图上传成功
    handleDetailSuccess: function handleDetailSuccess(response, file) {
      if (response.code === 200) {
        this.formData.detailImg = response.data;
        this.$message.success('详情图上传成功');
      } else {
        this.$message.error(response.message || '详情图上传失败');
      }
    },
    // 封面图上传失败
    handleCoverError: function handleCoverError(err, file, fileList) {
      this.$message.error('封面图上传失败: ' + (err.message || '未知错误'));
    },
    // 详情图上传失败
    handleDetailError: function handleDetailError(err, file, fileList) {
      this.$message.error('详情图上传失败: ' + (err.message || '未知错误'));
    },
    // 删除封面图
    handleRemoveCover: function handleRemoveCover() {
      this.formData.coverImg = '';
    },
    // 删除详情图
    handleRemoveDetail: function handleRemoveDetail() {
      this.formData.detailImg = '';
    },
    // 组件销毁前释放资源
    beforeDestroy: function beforeDestroy() {
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 加载配置
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var loadingInstance, response, _t7;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              loadingInstance = null;
              _context7.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取活动列表
              _context7.next = 2;
              return (0, _communityHomeAct.getCommunityHomeActPage)({
                page: this.currentPage,
                limit: this.pageSize,
                name: this.actName
              });
            case 2:
              response = _context7.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.records) {
                // 直接使用返回的数据
                this.activityList = response.records.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    enable: item.status === true // 将status转换为enable字段用于显示
                  });
                });
                this.total = response.total;
                this.pageSize = response.size;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              _context7.next = 4;
              break;
            case 3:
              _context7.prev = 3;
              _t7 = _context7["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('配置加载失败:', _t7);
              this.$message.error('配置加载失败: ' + (_t7.message || '未知错误'));
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[1, 3]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }()
  }
};